import { cn } from '@/lib/utils';

export function MailArchiverIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="#1a9dd9"
      shapeRendering="crispEdges"
      className={cn('shrink-0', className)}
      aria-hidden="true"
    >
      <rect x="2" y="2" width="1" height="10" />
      <rect x="13" y="2" width="1" height="11" />
      <rect x="4" y="4" width="1" height="7" />
      <rect x="11" y="4" width="1" height="7" />
      <rect x="2" y="2" width="12" height="1" />
      <rect x="4" y="4" width="8" height="1" />
      <rect x="4" y="10" width="8" height="1" />
      <rect x="3" y="12" width="11" height="1" />
      <rect x="5" y="5" width="1" height="1" />
      <rect x="10" y="5" width="1" height="1" />
      <rect x="6" y="6" width="1" height="1" />
      <rect x="9" y="6" width="1" height="1" />
      <rect x="7" y="7" width="2" height="1" />
    </svg>
  );
}

export function isMailArchiverApp(appId?: string): boolean {
  return appId?.toLowerCase() === 'mailarchiver';
}
